module.exports = "../images/icon-gallery.png?v=d05e2e1";